import { MenuListButton } from '../menu-list-button';
import { MenuItem } from '../menu-list-item';

import type { TMenuItemType } from './models';

export type TMenuItem = {
    [key in TMenuItemType | 'link']: key extends 'link'
        ? typeof MenuItem
        : key extends 'header'
        ? typeof MenuItem
        : key extends 'button'
        ? typeof MenuListButton
        : never;
};

export const MENU_ITEMS_CONFIG: TMenuItem = {
    button: MenuListButton,
    header: MenuItem,
    link: MenuItem,
};
